import React from 'react';
import { ArrowRight, Heart, Target, Zap } from 'lucide-react';

export const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-background">
        <img 
          src="https://customer-assets.emergentagent.com/job_heath-wellbeing/artifacts/zdmtwyhf_IMG_6780.jpeg"
          alt="Heath teaching wellbeing principles"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="hero-content">
        <div className="container">
          <div className="hero-text">
            <h1 className="display-large hero-title">
              Where Strength Meets Soul
            </h1>
            <p className="body-large hero-subtitle">
              True vitality isn't built through extremes, ego, or punishment. 
              It's built through self-respect. Through discipline rooted in devotion. 
              Through aligning body, mind, spirit and purpose.
            </p>
            
            <div className="hero-pillars">
              <div className="pillar-item">
                <div className="pillar-icon">
                  <Target size={24} />
                </div>
                <span>Strong Body</span>
              </div>
              <div className="pillar-item">
                <div className="pillar-icon">
                  <Zap size={24} />
                </div>
                <span>Clear Mind</span>
              </div>
              <div className="pillar-item">
                <div className="pillar-icon">
                  <Heart size={24} />
                </div>
                <span>Regulated System</span>
              </div>
            </div>

            <div className="hero-cta">
              <a 
                href="https://wa.me/61478694929" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn-primary btn-large"
              >
                Book a Consultation
                <ArrowRight size={20} />
              </a>
              <button onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })} className="btn-secondary btn-large">
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
